/**
 * Locks the Easify "Embalagem premium" toggle for The Hundred products.
 *
 * The Hundred products are identified by the Shopify product tag "premium".
 * Waits for the Easify block to render, then sets pointer-events: none on the
 * po-switch-root (the interactive child) and cursor: not-allowed on the option
 * div itself, so the cursor only appears on the correct toggle area.
 */
(function () {
  if (!window.__lockEmbalagemPremium) return;

  var selector = '[data-option-id="fa13ab3f-d153-49e6-b0d6-7cdb03611794"]';

  var observer = new MutationObserver(function () {
    var el = document.querySelector(selector);
    if (!el) return;
    el.style.cursor = 'not-allowed';
    var switchRoot = el.querySelector('.po-switch-root');
    if (switchRoot) switchRoot.style.pointerEvents = 'none';
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
